<div class="layout-menu">
  <p-panelMenu [model]="items" class="w-max" [multiple]="false"></p-panelMenu>
</div>
